var React = require('react');

function FileIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentcolor","fillRule":"evenodd","d":"M5.385 12.308a.77.77 0 000 1.538h9.23a.769.769 0 100-1.538h-9.23zm0 4.615a.769.769 0 100 1.539h9.23a.769.769 0 100-1.539h-9.23zm8.461-12.308V1.538l4.616 4.616h-3.077c-.85 0-1.539-.69-1.539-1.539zm3.077 18.462H3.077c-.85 0-1.539-.69-1.539-1.539V3.077c0-.85.69-1.539 1.539-1.539h9.21a94.23 94.23 0 00.02 3.077c0 1.7 1.378 3.077 3.078 3.077h3.077v13.846c0 .85-.69 1.539-1.539 1.539zM13.846 0H3.076A3.077 3.077 0 000 3.077v18.461c0 1.7 1.378 3.077 3.077 3.077h13.846c1.7 0 3.077-1.377 3.077-3.077V6.154L13.846 0z"}));
}

FileIcon.defaultProps = {"viewBox":"0 0 20 25"};

module.exports = FileIcon;

FileIcon.default = FileIcon;
